/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { NodeCompat } from '../../../compat/NodeCompat';
import { Constants } from '../../../core/Constants';
import { DocumentType } from '../../../core/models/DocumentType';
import { ExternalDocumentation } from '../../../core/models/common/ExternalDocumentation';
import { IServerParent } from '../../../core/models/common/IServerParent';
import { Info } from '../../../core/models/common/Info';
import { Server } from '../../../core/models/common/Server';
import { Tag } from '../../../core/models/common/Tag';
import { OasDocument } from '../../models/OasDocument';
import { OasPaths } from '../../models/OasPaths';
import { OasSecurityRequirement } from '../../models/OasSecurityRequirement';

/**
 * Constructor.
 * @class
 * @extends OasDocument
 * @author eric.wittmann@gmail.com
 */
export class Oas30Document extends OasDocument implements IServerParent {
    public openapi : string;

    public servers : Array<Server>;

    public components : Oas30Components;

    public constructor() {
        super();
        if(this.openapi===undefined) this.openapi = null;
        if(this.servers===undefined) this.servers = null;
        if(this.components===undefined) this.components = null;
        this.openapi = Constants.OPEN_API_30_DEFAULT_VERSION;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Document#getDocumentType()
     * @return {DocumentType}
     */
    public getDocumentType() : DocumentType {
        return DocumentType.openapi3;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasDocument#createPaths()
     * @return {OasPaths}
     */
    public createPaths() : OasPaths {
        let rval : OasPaths = new Oas30Paths();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasDocument#createSecurityRequirement()
     * @return {OasSecurityRequirement}
     */
    public createSecurityRequirement() : OasSecurityRequirement {
        let requirement : OasSecurityRequirement = new Oas30SecurityRequirement();
        requirement._ownerDocument = this;
        requirement._parent = this;
        return requirement;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Document#createInfo()
     * @return {Info}
     */
    public createInfo() : Info {
        let info : Info = new Oas30Info();
        info._ownerDocument = this;
        info._parent = this;
        return info;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Document#createTag()
     * @return {Tag}
     */
    public createTag() : Tag {
        let tag : Tag = new Oas30Tag();
        tag._ownerDocument = this;
        tag._parent = this;
        return tag;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Document#createExternalDocumentation()
     * @return {ExternalDocumentation}
     */
    public createExternalDocumentation() : ExternalDocumentation {
        let ed : ExternalDocumentation = new Oas30ExternalDocumentation();
        ed._ownerDocument = this;
        ed._parent = this;
        return ed;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.IServerParent#createServer()
     * @return {Server}
     */
    public createServer() : Server {
        let rval : Oas30Server = new Oas30Server();
        rval._ownerDocument = this;
        rval._parent = this;
        return rval;
    }

    public addServer$java_lang_String$java_lang_String(url : string, description : string) : Server {
        let server : Server = this.createServer();
        server.url = url;
        server.description = description;
        if(this.servers == null) {
            this.servers = <any>([]);
        }
        /* add */(this.servers.push(server)>0);
        return server;
    }

    /**
     * Adds a server.
     * @param {string} url
     * @param {string} description
     * @return {Server}
     */
    public addServer(url? : any, description? : any) : any {
        if(((typeof url === 'string') || url === null) && ((typeof description === 'string') || description === null)) {
            return <any>this.addServer$java_lang_String$java_lang_String(url, description);
        } else if(((url != null && url instanceof <any>Server) || url === null) && description === undefined) {
            return <any>this.addServer$io_apicurio_datamodels_core_models_common_Server(url);
        } else throw new Error('invalid overload');
    }

    /**
     * Creates an OAS 3.0 Components object.
     * @return {Oas30Components}
     */
    public createComponents() : Oas30Components {
        let rval : Oas30Components = new Oas30Components();
        rval._ownerDocument = this;
        rval._parent = this;
        return rval;
    }

    public addServer$io_apicurio_datamodels_core_models_common_Server(server : Server) {
        if(this.servers == null) {
            this.servers = <any>([]);
        }
        /* add */(this.servers.push(server)>0);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.IServerParent#getServer(java.lang.String)
     * @param {string} url
     * @return {Server}
     */
    public getServer(url : string) : Server {
        if(this.servers != null) {
            for(let index164=0; index164 < this.servers.length; index164++) {
                let server = this.servers[index164];
                {
                    if(NodeCompat.equals(server.url, url)) {
                        return server;
                    }
                }
            }
        }
        return null;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.IServerParent#getServers()
     * @return {Server[]}
     */
    public getServers() : Array<Server> {
        return this.servers;
    }
}
Oas30Document["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Document";
Oas30Document["__interfaces"] = ["io.apicurio.datamodels.core.models.common.ISecurityRequirementParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent","io.apicurio.datamodels.core.models.common.IServerParent"];





import { Oas30Server } from './Oas30Server';


import { Oas30ExternalDocumentation } from './Oas30ExternalDocumentation';


import { Oas30Tag } from './Oas30Tag';


import { Oas30Info } from './Oas30Info';


import { Oas30SecurityRequirement } from './Oas30SecurityRequirement';


import { Oas30Paths } from './Oas30Paths';


import { Oas30Components } from './Oas30Components';

